// Function to fetch airport list 
import axios from 'axios';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const token = localStorage.getItem('token');
console.log(token);

export async function fetchAirportList(AirportQuery) {
    console.log("AirportList Request", AirportQuery)
    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/Admin/GetAirportList`,
            AirportQuery,
            {
                headers: {

                    'Authorization': `Bearer ${token}`,
                    'Content-Type': "application/json"
                }
            }
        );
        console.log(response)   
        return response.data;
    } catch (error) {
        console.error('Failed to fetch airport list:', error);
        throw error;
    }
}

// Add Airport 

export async function AddUpdateAirport(payload) {
    console.log("Add Airport Request", payload)
    
    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/Admin/AddUpdateAirport`,
            payload,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            }
        );
    
        if (response.status === 401 || response?.data?.Status === 401) {
            window.location.href = "/login";    
            return;
        }
        return response.data;
    } catch (error) {
        console.error('Failed to fetch airport list:', error);
        throw error;
    }
}

export async function deleteAirport(airportId) {
    console.log("Delete Airport Request", airportId);
    // console.log(token)

    // const payload = { Id: airportId };
    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/Admin/DeleteAirportById/${airportId}`,
            {},
            {
                headers: {

                    'Authorization':`Bearer ${token}`,
                    'Content-Type': "application/json",
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Failed to delete airport:', error);
        throw error;
    }
}



